export default class Property {
    constructor() {
        this._UserId = null;
        this._Email = null;
        this._Address = null;
        this._Price = null;
        this._DownPayment = null;
        this._AppreciationPctAnnual = null;
        this._InterestRateAnnual = null;
        this._RepairCostsAnnual = null;
        this._RentalPerMonth = null;
        this._InsuranceAnnual = null;
        this._TaxesAnnual = null;
        this._HoaAnnual = null;
        this._RentalAppreciationPctAnnual = null;
        this._Zestimate = null;
        this._RentZestimate = null;
        this._STRPropertyMgmtPct = null;
        this._STROccupancyPct = null;
        this._STRAverageDailyRate = null;
        this._UtilitiesAnnual = null;
        this._STRAnnualIncreasePct = null;
    }

    toDTO() {
        return {
            UserId: this.UserId,
            Email: this.Email,
            Address: this.Address.toDTO(),
            Price: this.Price,
            DownPayment: this.DownPayment,
            AppreciationPctAnnual: this.AppreciationPctAnnual,
            InterestRateAnnual: this.InterestRateAnnual,
            RepairCostsAnnual: this.RepairCostsAnnual,
            RentalPerMonth: this.RentalPerMonth,
            InsuranceAnnual: this.InsuranceAnnual,
            TaxesAnnual: this.TaxesAnnual,
            HoaAnnual: this.HoaAnnual,
            RentalAppreciationPctAnnual: this.RentalAppreciationPctAnnual,
            Zestimate: this.Zestimate,
            RentZestimate: this.RentZestimate,
            STRPropertyMgmtPct: this.STRPropertyMgmtPct,
            STROccupancyPct: this.STROccupancyPct,
            STRAverageDailyRate: this.STRAverageDailyRate,
            STRAnnualIncreasePct: this.STRAnnualIncreasePct,
            UtilitiesAnnual: this.UtilitiesAnnual,
            CreatedAt: new Date(),
            UpdatedAt: new Date().getTime()
        };
    }


    get UserId() {
        return this._UserId;
    }

    set UserId(value) {
        this._UserId = value;
    }

    get Email() {
        return this._Email;
    }

    set Email(value) {
        this._Email = value;
    }

    get Address() {
        return this._Address;
    }

    set Address(value) {
        this._Address = value;
    }

    get Price() {
        return this._Price;
    }

    set Price(value) {
        this._Price = value;
    }

    get DownPayment() {
        return this._DownPayment;
    }

    set DownPayment(value) {
        this._DownPayment = value;
    }

    get AppreciationPctAnnual() {
        return this._AppreciationPctAnnual;
    }

    set AppreciationPctAnnual(value) {
        this._AppreciationPctAnnual = value;
    }

    get InterestRateAnnual() {
        return this._InterestRateAnnual;
    }

    set InterestRateAnnual(value) {
        this._InterestRateAnnual = value;
    }

    get RepairCostsAnnual() {
        return this._RepairCostsAnnual;
    }

    set RepairCostsAnnual(value) {
        this._RepairCostsAnnual = value;
    }

    get RentalPerMonth() {
        return this._RentalPerMonth;
    }

    set RentalPerMonth(value) {
        this._RentalPerMonth = value;
    }

    get InsuranceAnnual() {
        return this._InsuranceAnnual;
    }

    set InsuranceAnnual(value) {
        this._InsuranceAnnual = value;
    }

    get TaxesAnnual() {
        return this._TaxesAnnual;
    }

    set TaxesAnnual(value) {
        this._TaxesAnnual = value;
    }

    get HoaAnnual() {
        return this._HoaAnnual;
    }

    set HoaAnnual(value) {
        this._HoaAnnual = value;
    }

    get RentalAppreciationPctAnnual() {
        return this._RentalAppreciationPctAnnual;
    }

    set RentalAppreciationPctAnnual(value) {
        this._RentalAppreciationPctAnnual = value;
    }


    get Zestimate() {
        return this._Zestimate;
    }

    set Zestimate(value) {
        this._Zestimate = value;
    }

    get RentZestimate() {
        return this._RentZestimate;
    }

    set RentZestimate(value) {
        this._RentZestimate = value;
    }


    get STRPropertyMgmtPct() {
        return this._STRPropertyMgmtPct;
    }

    set STRPropertyMgmtPct(value) {
        this._STRPropertyMgmtPct = value;
    }

    get STROccupancyPct() {
        return this._STROccupancyPct;
    }

    set STROccupancyPct(value) {
        this._STROccupancyPct = value;
    }

    get STRAverageDailyRate() {
        return this._STRAverageDailyRate;
    }

    set STRAverageDailyRate(value) {
        this._STRAverageDailyRate = value;
    }

    get UtilitiesAnnual() {
        return this._UtilitiesAnnual;
    }

    set UtilitiesAnnual(value) {
        this._UtilitiesAnnual = value;
    }


    get STRAnnualIncreasePct() {
        return this._STRAnnualIncreasePct;
    }

    set STRAnnualIncreasePct(value) {
        this._STRAnnualIncreasePct = value;
    }
}
